import CommonText from 'common/components/entities/TextNew/ui/TextUi'
import React, { ComponentProps } from 'react'
import type {
  WebsiteThemeInterface,
  WebsiteTypographySettingsStylesInterface,
} from 'src/shared/types/website-settings-types'

export interface PublicPageTextProps
  extends Omit<ComponentProps<typeof CommonText>, 'textAlign'> {
  paragraph?: WebsiteTypographySettingsStylesInterface
  theme?: WebsiteThemeInterface
  textAlign?: ComponentProps<typeof CommonText>['textAlign']
  requiredField?: boolean
}

export const PublicPageText: React.FC<PublicPageTextProps> = ({
  paragraph,
  theme,
  style,
  textAlign = 'left',
  children,
  requiredField = false,
}) => {
  const hover = {
    backgroundColor: theme?.links.linkHoveredBackgroundColor,
  }

  const active = {
    backgroundColor: theme?.links.linkPressedBackgroundColor,
  }

  return (
    <CommonText
      linkColor={theme?.links.linkTextColor}
      color={theme?.text.paragraphTextColor}
      backgroundColor={theme?.text.paragraphBackgroundColor}
      fontFamily={paragraph?.fontFamily}
      fontSize={paragraph?.fontSize}
      lineHeight={paragraph?.lineHeight}
      letterSpacing={paragraph?.letterSpacing}
      fontStyle={paragraph?.fontStyle}
      fontWeight={paragraph?.fontWeight}
      textAlign={textAlign}
      mobileFontFamily={paragraph?.mobileFontFamily}
      mobileFontSize={paragraph?.mobileFontSize}
      mobileLineHeight={paragraph?.mobileLineHeight}
      mobileLetterSpacing={paragraph?.mobileLetterSpacing}
      mobileFontStyle={paragraph?.mobileFontStyle}
      mobileFontWeight={paragraph?.mobileFontWeight}
      linkHover={hover}
      linkActive={active}
      style={style}
      aria-required={true}
    >
      {children}
      {requiredField && (
        <span style={{ color: '#F10000' }} aria-hidden="true">
          {' '}
          *
        </span>
      )}
    </CommonText>
  )
}
